import axios from "axios";

import { camelToSnakeCase, snakeToCamelCase } from "@/shared/utils/utils";
import { LC_AUTH_TOKEN } from "@/shared/const/storageKeys";

export const api = axios.create({
  baseURL: __API__,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(LC_AUTH_TOKEN) || "";

  if (config.headers.Authorization === undefined && config.headers && token) {
    config.headers.Authorization = `Token ${token}`;
  }

  if (config.data) {
    if (!(config.data instanceof FormData)) {
      config.data = camelToSnakeCase(config.data);
    }
  }

  return config;
});

api.interceptors.response.use(
  (response) => {
    if (response.data) {
      response.data = snakeToCamelCase(response.data);
    }

    return response;
  },
  (error) => {
    if (error.response) {
      error.response.data = snakeToCamelCase(error.response.data);
    }

    return Promise.reject(error);
  }
);
